import type { IconSvgObject } from './types';

const Building06Icon: IconSvgObject = [
  ["path", { d: "M7.5 6.00986H10.5M7.5 9.01973L10.5 9M7.5 12.0099H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 22V17C11 16.4477 10.5523 16 10 16H8C7.44772 16 7 16.4477 7 17V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.0293 22H3V4C3 2.89543 3.89543 2 5 2H13.0293C14.1338 2 15.0293 2.89543 15.0293 4V8.00483M15.0293 22H21V10.0048C21 8.90026 20.1046 8.00483 19 8.00483H15.0293M15.0293 22V8.00483", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Building06Icon;
